import React, { useEffect, useState } from 'react';
import baseURL from '../url';
import './Motors.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCar,
    faFilter, // Ícono para el botón de filtros en mobile
} from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor, useLocation } from "react-router-dom";
import ProductosLoading from '../ProductosLoading/ProductosLoading';
import Navbar from '../Navbar/Navbar';

export default function Motors({ vehicleType }) {
    const location = useLocation();
    const idMarca = location.state?.idMarca || 1;

    const [productos, setProductos] = useState([]);
    const [marcas, setMarcas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filtrosVisibles, setFiltrosVisibles] = useState(false); // ✅ Estado para mostrar/ocultar todos los filtros

    const [filtros, setFiltros] = useState({
        marca: 'todas',
        ordenar: 'recientes'
    });


    useEffect(() => {
        handleFiltroChange('marca', idMarca);
        cargarProductos();
        cargarMarcas();
    }, [idMarca]);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php?vehicleType=${vehicleType}&soloActivos=1`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error);
                setLoading(false);
            });
    };

    const cargarMarcas = () => {
        fetch(`${baseURL}/marcasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setMarcas(data.marca || []);
            })
            .catch(error => console.error('Error al cargar marcas:', error));
    };

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || item.imagen5 || '/placeholder-car.png';
    };

    const obtenerNombreMarca = (producto) => {
        if (!producto.idMarca) return 'Sin marca';

        const marca = marcas.find(m => String(m.idMarca) === String(producto.idMarca));
        return marca ? marca.nombre : 'Sin marca';
    };

    const handleFiltroChange = (filtro, valor) => {
        setFiltros(prev => ({
            ...prev,
            [filtro]: valor
        }));
    };

    const obtenerMarquilla = (producto) => {
        if (producto.oferta === 'si') return { texto: 'OFERTA', clase: 'oferta' };
        if (producto.masVendido === 'si') return { texto: 'DESTACADOS', clase: 'mas-vendido' };
        if (producto.destacado === 'si') return { texto: 'DESTACADO', clase: 'destacado' };
        if (!producto.kilometros || parseInt(producto.kilometros) === 0) return { texto: 'DISPONIBLE', clase: 'disponible' };
        return { texto: 'DISPONIBLE', clase: 'disponible' };
    };

    const filtrarProductos = () => {
        let resultado = [...productos];

        if (filtros.marca !== 'todas') {
            resultado = resultado.filter(producto => {
                return String(producto.idMarca) === String(filtros.marca)
            });
        }

        if (filtros.ordenar === 'precio-asc') {
            resultado.sort((a, b) => parseFloat(a.precio || 0) - parseFloat(b.precio || 0));
        } else if (filtros.ordenar === 'precio-desc') {
            resultado.sort((a, b) => parseFloat(b.precio || 0) - parseFloat(a.precio || 0));
        } else if (filtros.ordenar === 'anio-desc') {
            resultado.sort((a, b) => parseInt(b.anio || 0) - parseInt(a.anio || 0));
        } else if (filtros.ordenar === 'anio-asc') {
            resultado.sort((a, b) => parseInt(a.anio || 0) - parseInt(b.anio || 0));
        } else if (filtros.ordenar === 'km-asc') {
            resultado.sort((a, b) => parseInt(a.kilometros || 0) - parseInt(b.kilometros || 0));
        } else {
            resultado.sort((a, b) => parseInt(b.idProducto || 0) - parseInt(a.idProducto || 0));
        }

        return resultado;
    };

    const productosFiltrados = filtrarProductos();
    const totalProductos = productosFiltrados.length;


    return (
        <><Navbar /><div className="stock-page-lateral brands-page">
            <div style={{height: '3rem'}}>
                
            </div>
            <div className="stock-container">
                <div className="stock-layout-lateral">
                    {/* ✅ Botón de Filtros para mobile */}
                    <button className="mobile-filtros-btn" onClick={() => setFiltrosVisibles(!filtrosVisibles)}>
                        <FontAwesomeIcon icon={faFilter} />
                        Filtros
                    </button>

                    {/* Contenido principal */}
                    <main className="stock-main">
                        {/* Header de resultados */}
                        <div className="resultados-header">
                            <span className="resultados-contador">
                                Mostrando 1-{Math.min(12, totalProductos)} de {totalProductos} vehículos
                            </span>
                            <div className="ordenar-container">
                                <label>Ordenar por</label>
                                <select
                                    value={filtros.ordenar}
                                    onChange={(e) => handleFiltroChange('ordenar', e.target.value)}
                                >
                                    <option value="recientes">Más nuevos</option>
                                    <option value="precio-asc">Precio: menor a mayor</option>
                                    <option value="precio-desc">Precio: mayor a menor</option>
                                    <option value="anio-desc">Año: más nuevo</option>
                                    <option value="anio-asc">Año: más antiguo</option>
                                    <option value="km-asc">Menos kilómetros</option>
                                </select>
                            </div>
                        </div>

                        {/* Grid de productos */}
                        {loading ? (
                            <ProductosLoading />
                        ) : (
                            <div className="stock-grid-lateral">
                                {productosFiltrados.length === 0 ? (
                                    <div className="no-productos">
                                        <FontAwesomeIcon icon={faCar} className="no-productos-icon" />
                                        <h3>No se encontraron vehículos</h3>
                                        <p>Prueba ajustando los filtros</p>
                                    </div>
                                ) : (
                                    productosFiltrados.map(producto => {
                                        const marquilla = obtenerMarquilla(producto);

                                        return (
                                            <Anchor
                                                key={producto.idProducto}
                                                to={`/producto/${producto.idProducto}/${producto.titulo.replace(/\s+/g, '-')}`}
                                                className="stock-card-lateral"
                                            >
                                                <div className="stock-card-image-lateral">
                                                    <img
                                                        src={obtenerImagen(producto)}
                                                        alt={producto.titulo}
                                                        loading="lazy" />
                                                    <div className="marca-logo">
                                                        <span>{obtenerNombreMarca(producto)}</span>
                                                    </div>
                                                    <div className={`stock-marquilla-lateral ${marquilla.clase}`}>
                                                        {marquilla.texto}
                                                    </div>
                                                </div>

                                                <div className="stock-card-content-lateral">
                                                    <h3 className="stock-card-title-lateral">
                                                        {producto.titulo}
                                                    </h3>

                                                    <div className="stock-card-specs-lateral">
                                                        <span>{producto.kilometros || 0} km</span>
                                                        <span>|</span>
                                                        <span>{producto.anio || 'N/A'}</span>
                                                        <span>|</span>
                                                        <span>{producto.combustible || 'Diesel'}</span>
                                                    </div>

                                                    <div className="stock-card-price-lateral">
                                                        <span className="precio-actual-lateral">
                                                            ${String(producto.precio || 0).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                        </span>
                                                    </div>
                                                </div>
                                            </Anchor>
                                        );
                                    })
                                )}
                            </div>
                        )}
                    </main>
                </div>
            </div>
        </div></>
    );
}